import {
    ExpenseSubMode,
    RevenueSubMode,
} from "@common/types/domains/accounting/schedule";
import { isPrepaidExpenseSubMode } from "./expenseSubMode";

/**
 * Deferred revenue and prepaid (or deferred) expense hold the whole amount
 * up front and draw it down; accrued schedules build month by month.
 */
export function isScheduleDeferringMode(options: {
    revenueSubMode: RevenueSubMode | null;
    expenseSubMode: ExpenseSubMode | null;
}): boolean {
    return (
        options.revenueSubMode === RevenueSubMode.deferred ||
        isPrepaidExpenseSubMode(options.expenseSubMode)
    );
}
